interface CalendarSummaryProps {
  noteCount: number;
  favoriteCount: number;
  daysJournaled: number;
}

// The mockup's ".cs-summary" card — a few muted label/value rows summarising the
// visible month. These are note-derived counts only; per-day money lives on the
// heatmap cells and the timeline realized pills (server values, no FE math).
export function CalendarSummary({
  noteCount,
  favoriteCount,
  daysJournaled,
}: CalendarSummaryProps) {
  const rows: Array<{ label: string; value: string }> = [
    { label: "Notes this month", value: String(noteCount) },
    { label: "Favorites", value: String(favoriteCount) },
    { label: "Days journaled", value: String(daysJournaled) },
  ];
  return (
    <dl className="flex flex-col gap-2 rounded-card border border-outline-variant bg-surface-container px-3.5 py-3">
      {rows.map((row) => (
        <div key={row.label} className="flex items-center justify-between text-xs text-on-surface-muted">
          <dt>{row.label}</dt>
          <dd className="font-mono text-[13px] font-semibold text-on-surface">{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
